import * as types from "./types";

const INITIAL_STATE = {
  cards: {},
  filter: {},
  loading: false,
  error: false,
  login: false,
  token: null,
  url: "/",
  error_trello: false,
  textos: [],
  label: [],
  desgrabador: [],
  days: 3,
  media_source: "all",
  order: "-relevance_score",
  page: 1,
  search: null,
  category: null,
  loading_filter: false,
  loading_trello: false,
  trello: [],
  error_desgrabador: false,
  search_name: null,
  search_title: null,
  items_menu: [],
  messages: {},
  similares: {},
  user_data: [],
  filtros_app: {},
  new_pass: null,
  news_pass_status: false,
  new_data_user: null,
  new_data_user_success: false,
  error_new_data_user: false,
  list_users: {},
  list_users_delete_sucess: false,
  medios_user_qsch: {},
  medios_user_qsch_exist: false,
  code_new_user: {},
  code_new_user_status: "idle",
  first_password: {},
  first_password_status: "idle",
  reset_password: {},
  error_new_password: false,
  reset_password_complete: {},
  reset_password_complete_status: "idle",
  file_error: false,
  error_invitation: false,
  error_filter: false,
  error_monitoreo: false,
  redes_qsch: {},
  redes_qsch_exist: false,
  monitoreo_user: [],
  monitoreo_user_app_error: [],
  menu_usuarios: {},
  appministrador: [],
  appministrador_conversation: {},
  monitoreo_trello: false,
  appministrador_pedidos: {},
  messages_pedidos: {},
  delete_pedido: false,
  page_conversation: 1,
  appministrador_conversation_results: [],
  veredictos: [],
  menu_appministrador: {},
  status_rta: false,
  grafico: [],

  monitoreo: null,
  monitoreo_id: {},
  caregorias_form: [],
  trendings: [],
  cards_monitoreo: null,
  desinformaciones_detalle: [],
  nuevo_registro: null,
  btn_registro: false,
  registro_status: "idle",
  nueva_categoria: [],
  nueva_desinformaciones: [],
  filtros_feed: [],
  desinformaciones: [],
  registro_status_manual: "idle",
  page_registrados: [],
  id_registro: null,
  id_registro_data: [],

  // REFACTOR

  categorias_detalle: [],
  status_trello: null,
  nuevo_id: null,
  next: null,
  expand: false,
  data: "idle",
  campanas: [],
  label_desgrabador: [],

  // REFACTOR MONITOREO JOACO
  monitoreo__current_form_is_open: false,
  monitoreo__current_form_id: null,
  monitoreo__current_form_publication_id: null,
  // ID of the card where the new publication loaded is gonna be stored
  monitoreo__load_publication_card_selected_id: null,
  monitoreo__card_selected: {},
  monitoreo__events: [],
  monitoreo__topics: [],
  monitoreo__subtopics: {},
  monitoreo__new_event: null,
  desgrabador_historial: [],
  desgrabador_historial_item: [],

  desgrabador_historial_fichero: [],
  desgrabador_historial_fichero_item: [],
  desgrabador_error: false,
  desgrabador_fichero_error: false,

  chequeador__current_form_is_open: false,
  chequeador__current_form_id: null,
  chequeador__current_form_publication_id: null,
  chequeador__verificiones: [],
  chequeador__verificiones__delete: false,
  chequeador__verificiones__id: {},
  chequeador__verificiones__new: {},
  chequeador__verificiones__new__save: {},
  chequeador__verificiones__rating: [],
  chequeador__verificiones__is__edit: false,
  chequeador__verificiones__borrador: null,
  chequeador__verificaciones__page: null,
  chequeador__verificaciones__borrador__data__editar: [],
  chequeador__verificaciones__borrador__data__nuevo: [],
  isUploadingFile: false,
  errorModal: false
};

function rootReducer(state = INITIAL_STATE, action) {
  console.log(action.type);
  
  switch (action.type) {
    // UI States
    case types.LOADING:
      return {
        ...state,
        loading: true
      };
    
  
      case types.FINISHED_LOADING: {
        return {
          ...state,
          loading: false,
        };
      }
  
      case types.FETCH_CARDS_SUCCESS: {
       console.log("entrando 2", action.payload.cards);
       
        return {
          ...state,
          cards: action.payload.cards,
          loading: false,
        };
      }

  
      case types.FETCH_FILTER_SUCCESS: {
        return {
          ...state,
          filter: action.payload.filter,
        };
      }
  
      case types.LOGIN: {
        return {
          ...state,
          login: action.payload.status,
        };
      }
  
      case types.RESET_MONITOREO_CREATE_NAME_ERROR: {
        return {
          ...state,
          error_monitoreo: false,
        }; 
      }

      case types.SHOW_ERROR_MODAL_CLOSE: {
        return {
          ...state,
          errorModal: false,
        }; 
      }
  

      case types.RESET_STORE: {
        return INITIAL_STATE;
      }
   
      case types.FETCH_TOKEN: {
        return {
          ...state,
          token: action.payload.token,
        };
      }
  
      case types.URL: {
        return {
          ...state,
          url: action.payload.url,
        };
      }
  
      case types.FILTER_FLAG: {
        return {
          ...state,
          loading_filter: true,
        };
      }
  
      case types.FILTER_FLAG_SUCCESS: {
        return {
          ...state,
          loading_filter: false,
          error: false,
        };
      }
  
      case types.FILTER_FLAG_ERROR: {
        return {
          ...state,
          error_filter: true,
        };
      }
  
      case types.FILTER_FLAG_MONITOREO: {
        return {
          ...state,
          error_monitoreo: true,
        };
      }
  
      case types.FETCH_DESGRABADOR: {
        return {
          ...state,
          desgrabador: action.payload.data,
        };
      }
      
      case types.SHOW_ERROR_MODAL:
        return {
          ...state,
          errorModal: true
        };

  
      case types.SET_LABEL_DESGRABADOR: {
  
        const existingSubtitles = Array.isArray(state.desgrabador.subtitles)
          ? state.desgrabador.subtitles
          : [];
  
        const subtitlesArray = action.payload.data.map((el, index) => {
          return {
            ...existingSubtitles[index],
            ...el,
          };
        });
  
        return {
          ...state,
          desgrabador: {
            ...state.desgrabador,
            subtitles: [...subtitlesArray],
          },
          label: [...subtitlesArray],
          error: false,
        };
      }
  
      case types.SET_LABEL_TRELLO: {
        const newCards = state.cards.claims
          .filter((el) => el.id === action.payload.id)
          .map((el, index) => {
            return { ...state.cards.claims[index], ...el };
          });
        return {
          ...state,
          trello: [...newCards],
          error: false,
        };
      }
  
      case types.FETCH_TRELLO: {
        return {
          ...state,
          loading_trello: true,
        };
      }
  
      case types.CHANGE_VIEW: {
        return {
          ...state,
          expand: !state.expand,
        };
      }
  
      case types.FETCH_TRELLO_SUCCESS: {
        return {
          ...state,
          error_trello: false,
          loading_trello: false,
        };
      }
  
      case types.FETCH_TRELLO_ERROR: {
        return {
          ...state,
          error_trello: true,
        };
      }
  
      case types.FETCH_TEXTOS: {
        return {
          ...state,
          textos: action.payload.data,
        };
      }
  
      case types.FETCH_DAYS: {
        return {
          ...state,
          days: action.payload.data,
        };
      }
  
      case types.FETCH_QUERY: {
        return {
          ...state,
          search: action.payload.data,
        };
      }
  
      case types.FETCH_QUERY_NAME: {
        return {
          ...state,
          search_name: action.payload.data,
        };
      }
  
      case types.FETCH_QUERY_TITLE: {
        return {
          ...state,
          search_title: action.payload.data,
        };
      }
  
      case types.FETCH_PAGE: {
        return {
          ...state,
          page: action.payload.data,
        };
      }
  
      case types.FETCH_PAGE_CONVERSACION: {
        return {
          ...state,
          page_conversation: action.payload.data,
        };
      }
  
      case types.FETCH_MEDIA: {
        return {
          ...state,
          error: true,
          media_source: action.payload.data,
        };
      }
  
      case types.FETCH_ORDER: {
        return {
          ...state,
          error: true,
          order: action.payload.data,
        };
      }
  
      case types.FETCH_CATEGORY: {
        return {
          ...state,
          error: true,
          category: action.payload.data,
        };
      }
  
      case types.FETCH_CARD_STATUS: {
        return {
          ...state,
        };
      }
  
      case types.FETCH_FAILURE: {
        return {
          ...state,
          error: true,
        };
      }
  
      case types.FETCH_MESSAGES_APPMINISTRADOR_SUCCESS: {
       
        return {
          ...state,
          appministrador: action.payload.data,
          loading: false,
        };
      }
  
      case types.POST_MESSAGES_APPMINISTRADOR_REQUEST_VALIDATION: {
       
        return {
          ...state,
          appministrador: action.payload.data,
          loading: false,
        };
      }
  
      case types.FILTER_SIMILAR: {
        return {
          ...state,
          messages: action.payload.items,
        };
      }
  
      case types.FETCH_ITEMS_MENU: {
  
        return {
          ...state,
          items_menu: action.payload.items,
        };
      }
  
      case types.FETCH_USER: {
        return {
          ...state,
          user_data:  action.payload.data,
        };
      }
  
      case types.FETCH_FILTER_APP_SUCCESS: {
       
        return {
          ...state,
          filtros_app: action.payload.filter,
        };
      }
  
      case types.FETCH_NEW_PASS: {
        return {
          ...state,
          new_pass: action.payload.pass,
          new_pass_status: true,
        };
      }
  
      case types.FETCH_NEW_USER_DATA: {
        return {
          ...state,
          new_data_user: action.payload.data,
          new_data_user_success: true,
        };
      }
  
      case types.FETCH_LIST: {
        return {
          ...state,
          list_users: action.payload.data,
        };
      }
  
      case types.FETCH_INVITATION: {
        return {
          ...state,
          list_users_post_status: true,
        };
      }
  
      case types.FETCH_DELETE_INVITATION: {
        return {
          ...state,
          list_users_delete_sucess: true,
        };
      }
  
      case types.FETCH_DELETE_PEDIDO: {
        return {
          ...state,
          delete_pedido: action.payload.data,
          loading: false,
        };
      }
  
      case types.FETCH_MEDIOS_USER_QSCH: {
        return {
          ...state,
          medios_user_qsch: action.payload.data,
          medios_user_qsch_exist: true,
        };
      }
  
      case types.FETCH_CODE_NEW_USER: {
        return {
          ...state,
          code_new_user: action.payload.data,
          code_new_user_status: "success",
        };
      }
  
      case types.FETCH_CODE_NEW_USER_FAIL: {
        return {
          ...state,
          code_new_user_status: "error",
        };
      }
  
      case types.FETCH_FIRST_PASS: {
        return {
          ...state,
          first_password: action.payload.data,
          first_password_status: "success",
        };
      }
  
      case types.FETCH_FIRST_PASS_FAILURE: {
        return {
          ...state,
          first_password_status: "error",
        };
      }
  
      case types.ERROR_NEW_PASSWORD: {
        return {
          ...state,
          error_new_password: action.payload.status,
        };
      }
  
      case types.ERROR_INVITATION: {
        return {
          ...state,
          error_invitation: action.payload.status,
        };
      }
  
      case types.ERROR_FILE: {
        return {
          ...state,
          file_error: action.payload.status,
        };
      }
  
      case types.ERROR_NEW_DATA: {
        return {
          ...state,
          error_new_data_user: action.payload.status,
        };
      }
  
      case types.RESET_PASSWORD_COMPLETE: {
        return {
          ...state,
          reset_password_complete: action.payload.data,
          reset_password_complete_status: "success",
        };
      }
  
      case types.RESET_PASSWORD_COMPLETE_FAILURE: {
        return {
          ...state,
          reset_password_complete_status: "error",
        };
      }
  
      case types.FETCH_FILE_SUCCESS: {
        return {
          ...state,
          file: true,
          loading: false,
        };
      }
  
      case types.FETCH_REDES_SUCCESS: {
        return {
          ...state,
          redes_qsch: action.payload.redes,
          loading: false,
          redes_qsch_exist: true,
        };
      }
  
      case types.FETCH_MONITOREO_USER_SUCCESS: {
        return {
          ...state,
          monitoreo_user: action.payload.cards,
          loading: false,
        };
      }
  
      case types.FETCH_MONITOREO_USER_APP_ERROR: {
        return {
          ...state,
          monitoreo_user_app_error: action.payload.tems,
        };
      }
  
      case types.FETCH_MENU_USUARIOS_SUCCESS: {
        return {
          ...state,
          menu_usuarios:action.payload.tems,
          loading: false,
        };
      }
  
      case types.FETCH_TRELLO_MONITOREO_REQUEST: {
        return {
          ...state,
          monitoreo_trello: false,
          loading: true,
        };
      }
  
      case types.FETCH_TRELLO_MONITOREO_SUCCESS: {
        return {
          ...state,
          monitoreo_trello: true,
          loading: false,
        };
      }
  
      case types.FETCH_PEDIDOS_REQUEST: {
        return {
          ...state,
          loading: true,
        };
      }
  
      case types.FETCH_PEDIDOS_SUCCESS: {
        return {
          ...state,
          appministrador_pedidos: action.payload.cards,
          loading: false,
        };
      }
  
      case types.FETCH_MESSAGES_APPMINISTRADOR_PEDIDOS_SUCCESS: {
        return {
          ...state,
          messages_pedidos: action.payload.cards,
          loading: false,
        };
      }
  
      case types.POST_RESPONSE_SUCCESS: {
        return {
          ...state,
          loading: false,
          status_rta: false,
        };
      }
  
      case types.POST_RESPONSE_FAILURE: {
        return {
          ...state,
          loading: false,
          status_rta: true,
        };
      }
  
      case types.FETCH_SIMILARES_SUCCESS: {
        return {
          ...state,
          similares: action.payload.cards,
          loading: false,
        };
      }
  
      case types.FETCH_VEREDICTOS_SUCCESS: {
        return {
          ...state,
          veredictos:action.payload.veredictos,
          loading: false,
        };
      }
  
      case types.FETCH_MENU_APP_SUCCESS: {
        return {
          ...state,
          menu_appministrador: action.payload.menu,
          loading: false,
        };
      }
  
      case types.FETCH_GRAFICO_SUCCESS: {
        return {
          ...state,
          grafico: action.payload.grafico,
          loading: false,
        };
      }
  
      case types.FETCH_FILTER_APPMINISTRADOR: {
        return {
          ...state,
          filter_app: action.payload.filter_app,
        };
      }
  
      // NUEVO MONITOREO reducer
  
      case types.FETCH_MONITOREO_SUCCESS: {
        return {
          ...state,
          monitoreo: action.payload.items,
          loading: false,
        };
      }
  
      case types.FETCH_MONITOREO_SUCCESS_TRENDINGS: {
        return {
          ...state,
          trendings: action.payload.items,
          loading: false,
        };
      }
  
      case types.FETCH_CATEGORIAS_DETALLE_SUCCESS: {
        return {
          ...state,
          categorias_detalle: action.payload.categorias_detalle,
          loading: false,
        };
      }
  
      case types.FETCH_MONITOREO_SUCCESS_ID: {
        return {
          ...state,
          monitoreo_id: action.payload.items,
          loading: false,
        };
      }
  
      case types.FETCH_MONITOREO_SUCCESS_CATEGORIAS_FORM: {
        return {
          ...state,
          categorias_form: action.payload.items,
          loading: false,
        };
      }
  
      case types.FETCH_MONITOREO_SUCCESS_CARDS: {
        return {
          ...state,
          cards_monitoreo: action.payload.items,
          loading: false,
        };
      }
  
      case types.FETCH_MONITOREO_SUCCESS_DESINFORMACIONES_DETALLE: {
        return {
          ...state,
          desinformaciones_detalle: action.payload.items,
          loading: false,
        };
      }
  
      case types.POST_MONITOREO_ASOCIADO_SUCCESS: {
        return {
          ...state,
          registro_status: "success",
        };
      }
  
      case types.FETCH_MONITOREO_ASOCIADO_FAILURE: {
        return {
          ...state,
          registro_status: "error",
        };
      }
  
      case types.RESET_REGISTRO_STATUS: {
        return {
          ...state,
          registro_status: "idle",
        };
      }
  
      case types.FETCH_NUEVA_DESINFORMACION_SUCCESS: {
        return {
          ...state,
          nueva_desinformaciones: action.payload.cards,
          loading: false,
          registro_status_manual: "success",
        };
      }
  
      case types.RESET_REGISTRO_STATUS_MANUAL_SUCCESS: {
        return {
          ...state,
          registro_status_manual: "success",
        };
      }
  
      case types.RESET_REGISTRO_STATUS_MANUAL_ERROR: {
        return {
          ...state,
          registro_status_manual: "error",
        };
      }
  
      case types.FETCH_MONITOREO_SUCCESS_DESINFORMACIONES_ID: {
        return {
          ...state,
          desinformaciones: action.payload.items,
          loading: false,
        };
      }
  
      case types.RESET_REGISTRO_STATUS_MANUAL: {
        return {
          ...state,
          registro_status_manual: "idle",
        };
      }
  
      case types.UPDATE_MONITOREO_CARDS: {
        const { cards, index } = action.payload;
        const updatedMonitoreo = [...state.monitoreo]; // Crea una copia del estado actual
        updatedMonitoreo[index].cards = cards; // Actualiza las cartas en el índice correspondiente
        return {
          ...state,
          monitoreo: updatedMonitoreo, // Devuelve el estado actualizado
        };
      }
  
      case types.FETCH_REGISTRADOS_PAGE_SUCCESS: {
        return {
          ...state,
          page_registrados: action.payload.items,
          loading: false,
        };
      }
  
      case types.FETCH_MONITOREO_SUCCESS_NUEVO_ID: {
        return {
          ...state,
          nuevo_id: action.payload.id,
          loading: false,
        };
      }
  
      case types.FETCH_REGISTRO_ID_SUCCESS: {
        return {
          ...state,
          id_registro: action.payload.id,
          loading: false,
        };
      }
  
      case types.FETCH_REGISTRO_ID_DATA_SUCCESS: {
        return {
          ...state,
          id_registro_data: action.payload.items,
          next: action.payload.items.next,
          loading: false,
        };
      }
  
      case types.FETCH_TRELLO_SUCCESS: {
        return {
          ...state,
          status_trello: action.payload.items,
          loading: false,
        };
      }
  
      case types.RESET_DESGRABADOR: {
        return {
          ...state,
          desgrabador: [],
          desgrabador_historial_item: [], 
          desgrabador_historial_fichero_item: [],
          label_desgrabador: [],
          error: false,
          desgrabador_fichero_error: false
  
        };
      }
      case types.FETCH_DATA_SUCCESS: {
        return {
          ...state,
          data: action.payload.status,
          loading: false,
        };
      }
  
      case types.FETCH_DATA_CAMPANAS_SUCCESS: {
        return {
          ...state,
          campanas: action.payload.items,
          loading: false,
        };
      }
  
      case types.MONITOREO__TOGGLE_FORM: {
        return {
          ...state,
          monitoreo__current_form_is_open: action.payload.openForm,
          monitoreo__current_form_id: action.payload.form_id,
          monitoreo__current_form_publication_id: action.payload.publication_id,
        };
      }
  
      case types.CHEQUEADOR__TOGGLE_FORM: {
        return {
          ...state,
          chequeador__current_form_is_open: action.payload.openForm,
          chequeador__current_form_id: action.payload.form_id,
          chequeador__current_form_publication_id: action.payload.publication_id,
        };
      }
  
      case types.MONITOREO__SET_LOAD_PUBLICATION_CARD_SELECTED_ID: {
        return {
          ...state,
          monitoreo__load_publication_card_selected_id: action.payload.cardSelectId,
        };
      }
  
      case types.MONITOREO__NEW_CARD_CREATED: {
        return {
          ...state,
          nuevo_registro: action.payload.newCard.id,
        };
      }
  
      case types.MONITOREO__FETCH_CARD_SELECTED: {
        return {
          ...state,
          monitoreo__card_selected: action.payload.items,
        };
      }
  
      case types.MONITOREO__FETCH_ALL_EVENTS: {
  
        action.payload.items.forEach((event) => {
          event.label = event.name;
          event.value = event.id;
        });
  
        return {
          ...state,
          monitoreo__events: action.payload.items,
        };
      }
  
      case types.MONITOREO__FETCH_ALL_TOPICS: {

        var subtopics = action.payload.items.reduce(function (map, obj) {
          map[obj.id] = obj.subtopics;
          return map;
        }, {});
  
        return {
          ...state,
          monitoreo__topics: action.payload.items,
          monitoreo__subtopics: subtopics,
        };
      }
  
      case types.MONITOREO__NEW_EVENT: {  
        return {
          ...state,
          monitoreo__new_event: action.payload.newEvent,
          loading: false,
        };
      }
  
      case types.FETCH_HITORIAL_DESGRABADOR: {
        return {
          ...state,
          desgrabador_historial: action.payload.items,
        };
      }
  
      case types.FETCH_HITORIAL_DESGRABADOR_ID: {
        return {
          ...state,
          desgrabador_historial_item: action.payload.items,
        };
      }
  
      case types.SET_LABEL_DESGRABADOR_HISTORIAL: {
  
        return {
          ...state,
          label_desgrabador: action.payload.data,
          error: false,
        };
      }
  
      case types.FETCH_HITORIAL_DESGRABADOR_FICHERO: {
        return {
          ...state,
          desgrabador_historial_fichero: action.payload.items,
        };
      }
  
      case types.FETCH_HITORIAL_DESGRABADOR_FICHERO_ID: {
        return {
          ...state,
          desgrabador_historial_fichero_item: action.payload.items,
        };
      }
  
      case types.FETCH_DESGRABADOR_ERROR: {
        return {
          ...state,
          desgrabador_error: true,
        };
      }
  
  
      case types.FETCH_DESGRABADOR_FICHERO_ERROR: {
        return {
          ...state,
          desgrabador_fichero_error: true,
        };
      }
  
      case types.FETCH_DESGRABADOR_ERROR_CLEAN: {
        return {
          ...state,
          desgrabador_error: false,
        };
      }
  
      case types.CLEAR_LABEL_DESGRABADOR:
        return {
          ...state,
          label_desgrabador: [],
        };
  
      /* CHEQUEADOR */
  
      case types.FETCH_VERIFICACIONES: {
        return {
          ...state,
          chequeador__verificiones: action.payload.data,
          chequeador__verificaciones__page: action.payload.data.next,
          loading: false,
        };
      }
  
      case types.FETCH_VERIFICACIONES_DELETE: {
        return {
          ...state,
          chequeador__verificiones__delete: true,
        };
      }
  
      case types.FETCH_VERIFICACIONES_ID: {
        return {
          ...state,
          chequeador__verificiones__id: action.payload.items,
          chequeador__verificiones__is__edit: true,
          loading: false,
        };
      }
  
      case types.FETCH_VERIFICACIONES_NEW: {
        return {
          ...state,
          chequeador__verificiones__new: action.payload.items,
          loading: false,
        };
      }
  
      case types.RESET_CHEQUEADOR_VERIFICACIONES_NEW:
        return {
          ...state,
          chequeador__verificiones__new: null,
          chequeador__verificiones__id: {},
          chequeador__verificiones__borrador: null
        };
  
  
      case types.FETCH_VERIFICACIONES_RATING: {
        return {
          ...state,
          chequeador__verificiones__rating: action.payload.items,
          loading: false,
        };
      }
      case types.UPDATE_VERIFICACION:
        return {
          ...state,
          chequeador__verificiones__id: action.payload.items,
          loading: false,
        };


      case types.UPDATE_VERIFICACION_IN_STORE:
        return {
          ...state,
          chequeador__verificiones__id: {
            ...state.chequeador__verificiones__id,
            ...action.payload,
          },
        };
  
      case types.VERIFICACIONES__IS__EDIT: {
        return {
          ...state,
          chequeador__verificiones__is__edit: true,
          loading: true,
        };
      }
  
      case types.VERIFICACIONES__BORRADOR: {
        return {
          ...state,
          chequeador__verificiones__borrador: action.payload.items,
          loading: true,
        };
      }
  
      case types.VERIFICACIONES__BORRADOR__DATA__EDITAR: {
        return {
          ...state,
          chequeador__verificaciones__borrador__data__editar: action.payload.items,
          loading: true,
        };
      }
      case types.VERIFICACIONES__BORRADOR__DATA__NUEVO: {
        return {
          ...state,
          chequeador__verificaciones__borrador__data__nuevo: action.payload.items,
          loading: true,
        };
      }
      case types.SET_UPLOADING_FILE: {
        return {
          ...state,
          isUploadingFile: action.payload.value,
          loading: true,
        };
      }
  
      case types.UPDATE_VERIFICACION: {
        return {
          ...state,
          chequeador__verificiones__id: action.payload.items,
          loading: false,
        };
      }
  

    default:
      return state;
  }
}

export default rootReducer;